import { render, staticRenderFns } from "./CustomStep.vue?vue&type=template&id=af3e10da&"
import script from "./CustomStep.vue?vue&type=script&lang=js&"
export * from "./CustomStep.vue?vue&type=script&lang=js&"
import style0 from "./CustomStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports